import { useEffect, useState } from "react";
import { apiFetch } from "../../api";
import { BASE_URL } from "../../../commonUrls";
import "./ForecastPanel.css";

export default function ForecastPanel() {
  const [forecast, setForecast] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch(`${BASE_URL}/spending/forecast`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { setForecast(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="fp-loading">Loading forecast…</div>;
  if (!forecast) return null;

  const daysTotal = forecast.daysElapsed + forecast.daysRemaining;
  const pct = Math.round((forecast.daysElapsed / daysTotal) * 100);

  return (
    <div className="fp-panel">
      <h3 className="fp-title">Month Forecast — {forecast.month}</h3>

      <div className="fp-stats">
        <FpStat label="Spent so far"        value={forecast.spentSoFar} />
        <FpStat label="Daily average"       value={forecast.dailyAverage} />
        <FpStat label="Projected month-end" value={forecast.projectedMonthEnd} accent />
        {forecast.topCategory && <FpStat label="Top category" value={forecast.topCategory} />}
      </div>

      {/* Month progress bar */}
      <div className="fp-progress-wrap">
        <div className="fp-progress-label">
          <span>Day {forecast.daysElapsed}</span>
          <span>{forecast.daysRemaining} days left</span>
        </div>
        <div className="fp-progress-bar">
          <div className="fp-progress-fill" style={{ width: pct + "%" }} />
        </div>
      </div>

      {/* Upcoming payments */}
      {forecast.upcomingPayments?.length > 0 && (
        <div className="fp-upcoming">
          <div className="fp-upcoming-title">Upcoming payments this month</div>
          {forecast.upcomingPayments.map((p, i) => (
            <div key={i} className="fp-payment-row">
              <span className="fp-payment-name">{p.title}</span>
              <span className="fp-payment-meta">{p.dueDate}</span>
              {p.amount && <span className="fp-payment-amount">{p.amount}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function FpStat({ label, value, accent }) {
  return (
    <div className={`fp-stat ${accent ? "fp-stat-accent" : ""}`}>
      <div className="fp-stat-value">{value}</div>
      <div className="fp-stat-label">{label}</div>
    </div>
  );
}
